import { Section } from "./Common";
import { addDays, dayShort, fmtShort, isoDow } from "../lib/fmt";

function cellState(data, m, ds, rset) {
  const nowHM = data.now.slice(11, 16);
  if (ds > data.today) return "future";
  if (!data.settings.workDays.includes(isoDow(ds)) || ds < m.createdAt.slice(0, 10)) return "off";
  if (data.leaves.some((l) => l.memberId === m.id && l.from <= ds && ds <= l.to)) return "leave";
  if (rset.has(`${m.id}_${ds}`)) return "filled";
  if (ds === data.today && nowHM < data.settings.deadline) return "pending";
  return "missed";
}

const CELL = {
  filled: <span className="block h-4 w-4 rounded-full bg-brand" />,
  missed: <span className="block h-4 w-4 rounded-full border-2 border-brand" />,
  off: <span className="block h-4 w-4 rounded-full bg-brand-line/50" />,
  future: <span className="block h-4 w-4 rounded-full border border-dashed border-[#c9b4b5]" />,
  pending: <span className="block h-4 w-4 rounded-full border-2 border-dashed border-brand/60" />,
  leave: <span className="hatch block h-4 w-4 rounded-full border border-brand-line" />,
};
const TITLE = { filled: "Terisi", missed: "Terlewat", off: "Bukan hari kerja", future: "Belum tiba", pending: "Menunggu batas", leave: "Cuti/izin" };

export default function DisciplineGrid({ data }) {
  const days = Array.from({ length: 7 }, (_, i) => addDays(data.date, i - 6));
  const rset = new Set(data.reports.map((r) => `${r.memberId}_${r.date}`));
  const members = data.team.filter((m) => m.mustReport).sort((a, b) => a.name.localeCompare(b.name));
  return (
    <Section id="discipline" eyebrow="Kedisiplinan 7 Hari" title="Siapa konsisten minggu ini">
      <div className="overflow-x-auto rounded-2xl border border-brand-line" data-testid="discipline-grid">
        <table className="w-full min-w-[520px] text-sm">
          <thead>
            <tr className="bg-brand-deep text-xs text-white">
              <th className="sticky left-0 z-10 bg-brand-deep px-3 py-2.5 text-left font-bold">Anggota</th>
              {days.map((d) => (
                <th key={d} className={`px-1 py-2 text-center font-semibold ${d === data.date ? "bg-brand" : ""}`}>
                  <div>{dayShort(d)}</div><div className="text-[10px] font-normal opacity-80">{fmtShort(d)}</div>
                </th>
              ))}
              <th className="px-3 py-2 text-right font-bold">Hari kerja</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-brand-line">
            {members.map((m) => {
              const states = days.map((d) => cellState(data, m, d, rset));
              const due = states.filter((s) => s === "filled" || s === "missed").length;
              const filled = states.filter((s) => s === "filled").length;
              return (
                <tr key={m.id} data-testid={`discipline-row-${m.id}`}>
                  <td className="sticky left-0 z-10 max-w-[130px] truncate bg-white px-3 py-2.5 font-semibold">{m.name}</td>
                  {states.map((s, i) => (
                    <td key={days[i]} className="px-1 py-2.5" title={TITLE[s]}><div className="flex justify-center">{CELL[s]}</div></td>
                  ))}
                  <td className="whitespace-nowrap px-3 py-2.5 text-right text-xs font-bold tabular-nums">{filled}/{due} hari kerja</td>
                </tr>
              );
            })}
            {members.length === 0 && <tr><td colSpan={9} className="p-4 text-sm text-[#7a6667]">Belum ada anggota wajib lapor.</td></tr>}
          </tbody>
        </table>
      </div>
      <div className="mt-3 flex flex-wrap gap-x-4 gap-y-2 text-xs text-[#7a6667]">
        {["filled", "missed", "pending", "leave", "off", "future"].map((k) => (
          <span key={k} className="inline-flex items-center gap-1.5">{CELL[k]} {TITLE[k]}</span>
        ))}
      </div>
    </Section>
  );
}
